const CARDS = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20yellow%20themed%20modern%20illustration%20with%20abstract%20banana%20silhouette%20elements%20blended%20with%20film%20strip%20patterns%20cinema%20motifs%20and%20play%20button%20icons%2C%20soft%20gradient%20background%20with%20warm%20cream%20and%20light%20golden%20tones%2C%20minimalist%20editorial%20style%2C%20clean%20composition&width=600&height=400&seq=card-bananavideo-03&orientation=landscape',
    title: '香蕉视频热播剧场',
    desc: '每日更新最新热播电视剧，高清全集不缓冲，追剧首选平台。',
    tag: '剧集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20coral%20peach%20themed%20digital%20illustration%20with%20elegant%20abstract%20peach%20fruit%20shapes%20merged%20with%20movie%20clapperboard%20and%20film%20reel%20elements%2C%20delicate%20gradient%20from%20light%20peach%20to%20cream%20background%2C%20cinematic%20flat%20design%20style%2C%20clean%20modern%20composition&width=600&height=400&seq=card-peachvideo-04&orientation=landscape',
    title: '蜜桃视频电影精选',
    desc: '汇聚国内外院线大片、经典电影，高清画质尽享观影盛宴。',
    tag: '电影',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20fresh%20green%20and%20white%20themed%20illustration%20with%20abstract%20watermelon%20slice%20patterns%20combined%20with%20streaming%20visuals%20and%20live%20broadcast%20iconography%2C%20light%20and%20refreshing%20color%20palette%2C%20minimalist%20vector%20style%2C%20editorial%20quality%20composition&width=600&height=400&seq=card-wmelonvideo-05&orientation=landscape',
    title: '西瓜视频综艺娱乐',
    desc: '热门综艺节目实时更新，欢乐不间断的娱乐盛宴。',
    tag: '综艺',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20pink%20cherry%20blossom%20themed%20digital%20art%20with%20delicate%20abstract%20cherry%20blossom%20petals%20floating%20around%20anime%20style%20visual%20elements%20and%20streaming%20motifs%2C%20dreamy%20light%20pink%20gradient%20background%2C%20elegant%20flat%20illustration%20style%2C%20harmonious%20composition&width=600&height=400&seq=card-sakuravideo-06&orientation=landscape',
    title: '樱花视频动漫番剧',
    desc: '最新番剧与经典动漫作品高清收录，二次元爱好者天堂。',
    tag: '动漫',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20amber%20and%20cream%20themed%20illustration%20with%20abstract%20candy%20shapes%20and%20documentary%20film%20elements%20like%20camera%20lens%20and%20timeline%20visuals%2C%20soft%20golden%20gradient%20background%2C%20minimalist%20editorial%20design%20style%2C%20clean%20sophisticated%20composition&width=600&height=400&seq=card-sweetvideo-07&orientation=landscape',
    title: '糖豆视频纪录精选',
    desc: '精品纪录片与人文纪实内容，深度探索世界的精彩。',
    tag: '纪录',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20pink%20red%20themed%20digital%20illustration%20with%20abstract%20cherry%20fruit%20clusters%20integrated%20with%20short%20video%20format%20visuals%20and%20social%20media%20style%20interface%20elements%2C%20warm%20playful%20background%2C%20trendy%20flat%20design%20style%2C%20energetic%20composition&width=600&height=400&seq=card-cherryvideo-08&orientation=landscape',
    title: '樱桃视频短剧专区',
    desc: '精品短剧快速追完，碎片时间也能享受完整故事。',
    tag: '短剧',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20earthy%20warm%20brown%20and%20cream%20themed%20illustration%20with%20abstract%20mushroom%20silhouettes%20paired%20with%20classic%20film%20elements%20like%20vintage%20projector%20and%20celluloid%20strips%2C%20nostalgic%20yet%20modern%20design%2C%20soft%20gradient%20background%2C%20editorial%20flat%20style%2C%20refined%20composition&width=600&height=400&seq=card-mushvideo-09&orientation=landscape',
    title: '蘑菇视频经典修复',
    desc: '经典老片修复版专区，重温影史不朽佳作。',
    tag: '经典',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          平台精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          七大视频平台特色内容一览
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-secondary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-1.5">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}